// Live tekstbewerking: t(key, fallback) markeert een bewerkbare plek en geeft
// bij server-render/eerste-paint altijd de fallback terug. De echte live
// override (indien aanwezig) wordt pas ná hydratatie client-side toegepast
// door components/LiveTexts.tsx — dit voorkomt een flits-van-verkeerde-inhoud
// en werkt ook als Firestore traag/onbereikbaar is.
export function t(key: string, fallback: string): string {
  return fallback;
}
